import { createContext, useContext, useMemo } from 'react';
import { type PropsWithChildren } from 'react';

interface CommentsContextProps {
  canDisplayEmojiPicker?: boolean;
  focusedCommentId?: number;
  focusedReplyId?: number;
  isOpenInModal?: boolean;
  options?: any;
  parentUrl?: string;
  sortBy?: string;
}

const defaultContextValue = {
  canDisplayEmojiPicker: undefined,
  focusedCommentId: undefined,
  focusedReplyId: undefined,
  isOpenInModal: undefined,
  options: undefined,
  parentUrl: undefined,
  sortBy: undefined,
};

const CommentsContext =
  createContext<CommentsContextProps>(defaultContextValue);

export const useCommentsContext = () => useContext(CommentsContext);

export const CommentsContextProvider = ({
  canDisplayEmojiPicker,
  children,
  focusedCommentId,
  focusedReplyId,
  isOpenInModal,
  options,
  parentUrl,
  sortBy,
}: PropsWithChildren<CommentsContextProps>) => {
  const value = useMemo(
    () => ({
      canDisplayEmojiPicker,
      focusedCommentId,
      focusedReplyId,
      isOpenInModal,
      options,
      parentUrl,
      sortBy,
    }),
    [
      canDisplayEmojiPicker,
      focusedCommentId,
      focusedReplyId,
      isOpenInModal,
      options,
      parentUrl,
      sortBy,
    ],
  );

  return (
    <CommentsContext.Provider value={value}>
      {children}
    </CommentsContext.Provider>
  );
};
